var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "building-template" },
    [
      _c("label", { class: { "required-flag": _vm.isEditing, bold: true } }, [
        _vm._v(_vm._s(_vm.$t("name"))),
      ]),
      _vm._v(" "),
      _c("TextField", {
        attrs: {
          showColon: false,
          readonly: !_vm.isEditing,
          label: "",
          value: _vm.templateDetail.title,
          required: true,
        },
        on: {
          updateValue: function (val) {
            return _vm.updateTemplateTitle(val)
          },
        },
      }),
      _vm._v(" "),
      _c("upload-photo-area", {
        attrs: {
          uploadSuccess: _vm.uploadSuccess,
          photoesInfo: _vm.templateList,
          selectEditPhotoInfo: _vm.selectEditPhotoInfo,
          isEditing: _vm.isEditing,
          allowEdit: _vm.allowEdit,
          updatePhotoInfo: _vm.updatePhotoInfo,
          deleteOnePhoto: _vm.deleteOnePhoto,
          beforeUpload: _vm.beforeUpload,
          deleteOnePhotoInfo: _vm.deleteOnePhotoInfo,
          onDragEnd: _vm.dragEnd,
          action: _vm.ActionTypes.settings.doc.hotbTemplate.create,
          additionalInfo: { buildingId: _vm.buildingId },
        },
      }),
      _vm._v(" "),
      !_vm.templateList.length && !_vm.isEditing
        ? _c("div", { staticClass: "empty-tips" }, [
            _c("p", [
              _vm._v(
                _vm._s(_vm.$t("setting.engineers.buildingTemplate.editMessage"))
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }